const texts = {
  en: {
    content: "a few of the videos I edited and/or made."
  },
  br: {
    content: "alguns poucos vídeos que fiz e/ou editei."
  }
};

export default texts;